module.exports = __webpack_public_path__ + "img/HZ-B5054.8c048bba.jpg";